import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IGatewayResponse } from '@/Module/Core/Model/ApiModel';
import type { IGetRandomLessonByCategoryId } from '@/Module/HomePage/Model/ApiModel/IGetRandomLessonByCategoryId';
import homeService from '@/Module/HomePage/Service/HomeService';
import type { ILessonSection } from '@/Module/Lesson/Model/DataModel';

export const getLessonListByCategoryIdAction = createAsyncThunk<
  IGatewayResponse<ILessonSection[]>,
  Omit<IGetRandomLessonByCategoryId, 'lessonCount'>
>('lesson/getLessonListByCategoryId', ({ categoryCategoryId }, { signal }) => {
  return homeService
    .getLessonByCategoryId(
      {
        lessonCount: 3,
        categoryCategoryId,
      },
      signal,
    )
    .then(({ data }) => data);
});
